<div [hidden]="isEditing">
    <div class="card p-3 mt-2">
        <header class="sub-header p-1">
            <h5>Module Mapping</h5>
            <button mat-icon-button class="add-btn-container p-1" matSuffix (click)="AddnewRoleMap()">
                <mat-icon>add</mat-icon> <span> Add Role-Map</span>
            </button>
        </header>
        <div class="mt-2 mb-3">
            <form [formGroup]="navlinkform">
                <div class="row mt-3">
                    <div class="col-md-4 col-lg-4 col-sm-12">
                        <mat-form-field class="flex-p w-100" appearance="outline">
                            <input matInput placeholder="Title" formControlName="link" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-lg-4 col-sm-12">
                        <mat-form-field class="flex-p w-100" appearance="outline">
                            <mat-select formControlName="role" placeholder="Role" multiple>
                              <mat-option *ngFor="let role of roles" [value]="role.id">
                                {{ role.name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>                          
                    </div>
                    <div class="col-md-4 col-lg-4 col-sm-12">
                        <div class="button-container">
                            <button (click)="GetSearchData()" class="btn btn-save btn-icon-text mb-2 mb-md-0 me-2">
                                <mat-icon>search</mat-icon>
                                Search
                            </button>
        
                            <button (click)="ClearSearch()" class="btn btn-cancel btn-icon-text mb-2 mb-md-0">
                                <mat-icon>clear</mat-icon>
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="table-responsive">
            <table mat-table matSort [dataSource]="dataSource"  class="table">
                <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef  mat-sort-header >Title
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.linkName}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="link">
                    <mat-header-cell *matHeaderCellDef mat-sort-header >Link Text
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.linkText}} </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="parent">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Parent Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element?.parentName != null ? element.parentName : '-'}}
                    </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="role">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Role
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.roleName}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="action">
                    <mat-header-cell fxFlex="80px" *matHeaderCellDef > Action </mat-header-cell>
                    <mat-cell fxFlex="100px" *matCellDef="let element">
                        <div class="table-actions-button-mat-cell">
                            <button mat-icon-button (click)="openUserDialog(element)" *ngIf="showEdit" class="action-btn edit-btn">
                                <mat-icon>mode_edit</mat-icon>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>
    
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </table>
        </div>
        <div *ngIf="dataSource.data.length == 0">
            <div class="no-results mt-5">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </div>
              <h1>No Results Found</h1>
            </div>
          </div>
            <mat-paginator #paginator [length]="resultsLength" [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20,50,100,500,1000]" showFirstLastButtons></mat-paginator>
        
    </div>
    

</div>


<div *ngIf="Navlink">
    <app-Rolemapping-dialog [SavedRoles]="SavedRoles" (submitRoles)="submitRoles($event)"></app-Rolemapping-dialog>
</div>
